import React from "react";
import { Box, Skeleton, Paper, useMediaQuery } from "@mui/material";
import PageContainer from "../PageContainer";
import PageSection from "../PageSection";

const UserManagementSkeleton: React.FC = () => {
  const isMdUp = useMediaQuery("(min-width:900px)");

  return (
    <PageContainer sx={{ mt: 2 }}>
      <PageSection sx={{ mb: 2 }}>
        {/* Search Section Skeleton */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              height: 48,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              display: "flex",
              alignItems: "center",
              px: 2,
              gap: 1,
            }}
          >
            {/* Search icon skeleton */}
            <Skeleton variant="circular" width={20} height={20} />
            {/* Search text skeleton */}
            <Skeleton variant="text" width="30%" height={20} />
          </Box>
        </Box>

        {/* User List Skeleton */}
        {isMdUp ? (
          // Desktop Card-based Layout Skeleton
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {Array.from({ length: 5 }).map((_, index) => (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 2,
                  p: 2.5,
                  minHeight: 80,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flex: 1,
                  }}
                >
                  {/* Avatar */}
                  <Skeleton variant="circular" width={40} height={40} />

                  {/* Name and phone */}
                  <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                    <Skeleton
                      variant="text"
                      width="60%"
                      height={20}
                      sx={{ mb: 0.5 }}
                    />
                    <Skeleton variant="text" width="40%" height={16} />
                  </Box>

                  {/* Date and actions */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Skeleton variant="text" width="80px" height={16} />
                    <Box sx={{ display: "flex", gap: 0.5 }}>
                      <Skeleton variant="circular" width={32} height={32} />
                      <Skeleton variant="circular" width={32} height={32} />
                      <Skeleton variant="circular" width={32} height={32} />
                    </Box>
                  </Box>
                </Box>
              </Paper>
            ))}
          </Box>
        ) : (
          // Mobile Card Skeleton
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {Array.from({ length: 3 }).map((_, index) => (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  p: 2.5,
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 2,
                  minHeight: 80,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flex: 1,
                  }}
                >
                  {/* Avatar */}
                  <Skeleton variant="circular" width={40} height={40} />

                  {/* Name and phone */}
                  <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                    <Skeleton
                      variant="text"
                      width="60%"
                      height={20}
                      sx={{ mb: 0.5 }}
                    />
                    <Skeleton variant="text" width="40%" height={16} />
                  </Box>

                  {/* Actions */}
                  <Box sx={{ display: "flex", gap: 0.5 }}>
                    <Skeleton variant="circular" width={32} height={32} />
                    <Skeleton variant="circular" width={32} height={32} />
                    <Skeleton variant="circular" width={32} height={32} />
                  </Box>
                </Box>
              </Paper>
            ))}
          </Box>
        )}
      </PageSection>
    </PageContainer>
  );
};

export default UserManagementSkeleton;
